import axiosInstance from '../axiosInterceptor/axiosInstance'

const getOrgSubscriptionStatus = async (data) => {
  const { orgId } = data

  const url = `v1/orgs/${orgId}/billing/status`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getOrgSubscriptionStatus
